import { render, staticRenderFns } from "./GroupedNeed.vue?vue&type=template&id=2f051d5c&"
import script from "./GroupedNeed.vue?vue&type=script&lang=js&"
export * from "./GroupedNeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GroupedNeed.vue"
export default component.exports